module.exports = __webpack_public_path__ + "static/media/armannunknown.8086798a.svg";